import { render, staticRenderFns } from "./DesignCommand.vue?vue&type=template&id=4dda296d&"
import script from "./DesignCommand.vue?vue&type=script&lang=js&"
export * from "./DesignCommand.vue?vue&type=script&lang=js&"
import style0 from "./DesignCommand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports